import ActiveInitialTermModule from '@/models/ActiveInitialTermModule'
import Company from '@/models/Company'
import MediaKpiModule from '@/models/MediaKpiModule'
import SystemDashboardWidget from '@/models/SystemDashboardWidget'
import simpleCard from '@/pages/ManagementDashboard/scripts/simple-card'
import moment from 'moment'
import numeral from 'numeral'

export default class ProfitInventoryMG extends SystemDashboardWidget {
  public key: string = 'profit-inventory-mg-custom-widget'

  public title = 'Inventory MG'

  public view = 'custom'

  public size = {
    lg: 12,
    md: 12,
    sm: 12,
  }

  public groups = {
    view: 'region',
  }

  public dataSourceRequest: any = null

  constructor(args: any = null) {
    super()

    if (args && args.dimensions) {
      this.dimensions = args.dimensions
    }

    if (args && args.metrics) {
      this.metrics = args.metrics
    }

    if (args && args.filters) {
      this.filters = Object.assign(this.filters, args.filters)
    }
    if (args && args.internalFilters) {
      this.internalFilters = Object.assign(this.internalFilters, args.internalFilters)
    }

    if (args && args.rightCol) {
      this.rightCol = args.rightCol
    }

    if (args && args.leftCol) {
      this.leftCol = args.leftCol
    }

    if (args && args.size) {
      this.size = args.size
    }

    if (args && args.title) {
      this.title = args.title
    }

    if (args && args.key) {
      this.key = args.key
    }

    if (args && args.updateFields) {
      this.fields = args.updateFields(this.fields)
    }

    if (args && args.internalQuery) {
      this.internalQuery = args.internalQuery
    }

    if (args && args.internalQueryPush) {
      if (!this.internalQuery) this.internalQuery = []
      this.internalQuery.push(args.internalQueryPush)
    }

    if (args && args.dataSourceRequest) {
      this.dataSourceRequest = args.dataSourceRequest
    }
  }

  public get filterToQuery() {
    let query = []

    if (this.filters.region !== 'all') {
      query.push(`region:${this.filters.region}`)
    }

    // query.push(`year:${this.internalFilters.year}`)

    query.push(`start:${moment(this.filters.start).format('YYYY-MM-DD')}`)
    query.push(`end:${moment(this.filters.end).format('YYYY-MM-DD')}`)

    return query
  }

  public get payload() {
    const query = [...new Set([...this.query, ...this.internalQuery, ...this.filterToQuery])]

    return {
      query,
      start: this.filters.start,
      end: this.filters.end,
    }
  }

  public dataSource() {
    if (this.dataSourceRequest) {
      const res = this.dataSourceRequest(this.payload)
      return res.then((r: any) => {
        if (r.hasOwnProperty('records')) {
          this.records = r.records
        }

        if (r.result) return r.result

        return r.data
      })
    }

    let request = new MediaKpiModule()
    return request.inventoryMG(this.payload).then((r: any) => {
      if (r.result) return r.result

      return r.data
    })
  }

  public get customData() {
    let data = this.data
    let acc = ''

    const calculate = (v: any) => {
      if (v.total_goals === 0 || v.total_impressions === 0) return 0
      const percentage = (v.total_impressions / v.total_goals) * 100
      return numeral(percentage * 0.01).format('0.0%')
    }

    data.forEach((item: any) => {
      let impressions = numeral(item.total_impressions).format('0.00a')
      let goal = numeral(item.total_goals).format('0.00a')
      let start = moment(item.start_at).format('MM/DD/YYYY')
      let end = moment(item.end_at).format('MM/DD/YYYY')

      acc += `
         <div class="col-xs-12 col-sm-6 col-md-6 col-lg-2 pb-4"> 
              <div class="card">
                  <div class="card-body">
                      <h5 class="card-title text-center">${item.name}</h5>
                  </div> 
                  <div class="card-body">
                      <div class="d-flex mb-2">
                        <h6 class="card-subtitle text-muted">YTD</h6>
                        <h6 class="ml-auto">${impressions}</h6>
                      </div>
                      <div class="d-flex mb-2">
                        <h6 class="card-subtitle text-muted">Target</h6>
                        <h6 class="ml-auto">${goal}</h6>
                      </div>
                      <div class="d-flex mb-2">
                        <h6 class="card-subtitle text-muted">%</h6>
                        <h6 class="ml-auto">${calculate(item)}</h6>
                      </div> 
                       <div class="d-flex mb-2">
                        <h6 class="card-subtitle text-muted">Start</h6>
                        <h6 class="ml-auto">${start}</h6>
                      </div>  
                       <div class="d-flex mb-2">
                        <h6 class="card-subtitle text-muted">End</h6>
                        <h6 class="ml-auto">${end}</h6>
                      </div>
                  </div>
              </div>
          </div>  
      `
    })

    return `
        <div class="row mt-4">
          ${acc}
        </div>
    `
  }
}
